var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grid-list-xl"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"lg12":"","sm12":"","xs12":""}},[_c('h3',{domProps:{"textContent":_vm._s("Essa é uma página de exemplo")}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }